/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        var isTouch; 

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            $('html').addClass('touch');
            isTouch = true;
        }else{
            $('html').addClass('no-touch');
            isTouch = false;
        }

        var browserW = $(window).width();
        var menuW = "200px";
        /*if(isTouch && browserW < 667){
            menuW = "100%";
            $('.off-menu').addClass('full');
        }else if(browserW < 667){
            menuW = "100%";
            $('.off-menu').addClass('full');
        }else{
            menuW = "200px";
        }*/
        $(document).foundation();
        $('.btn_menu').click(function(){
            if($(this).hasClass('close')){
                $(this).removeClass('close');
                $('.off-menu').removeClass('open');
                $('.container').animate({'left' : '0px'}, function(){
                $('.header_wrapper').css({'position' : 'fixed'});
            });
            }else{
                $(this).addClass('close');
                $('.off-menu').addClass('open');
                $('.container').animate({'left' : menuW});
                $('.header_wrapper').css({'position' : 'absolute'});
            }
        });
        $('.btn_down').click(function(){
            var windowH = $(window).height();
            $('body, html').animate({scrollTop: windowH}, 800);
        });
        $('.home_btn_down').click(function(){
            $('#fp-nav ul li a span').eq(1).trigger('click');
        });
        $('.caption_details').click(function(){
          if($(this).parent('.captionbox').hasClass('active')){
            $(this).parent('.captionbox').removeClass('active');
            $(this).find('.btn_open').html('+');
            $(this).siblings('p').css({'opacity' : 0});
          }else{
            $('.captionbox').removeClass('active');
            $('.btn_open').html('+');
            $('.captionbox p').css({'opacity' : 0});
            $(this).parent('.captionbox').addClass('active');
            $(this).find('.btn_open').html('-');
            $(this).siblings('p').css({'opacity' : 1});
          }
        });

        $('.btn_retail a').click(function(){
            ga('send', 'event', { eventCategory: 'RetailClick', eventAction: 'RetailClickMenu', eventLabel: 'RetailClickMenu'});
        });
        $('.btn_apply a').click(function(){
            ga('send', 'event', { eventCategory: 'ApplyNow', eventAction: 'ApplyNowMenu', eventLabel: 'ApplyNowMenu'});
        });
        $('.btn_resident a').click(function(){
            ga('send', 'event', { eventCategory: 'ResidentLogin', eventAction: 'ResidentLoginMenu', eventLabel: 'ResidentLoginMenu'});
        });
        $('#gform_submit_button_1').click(function(){
            ga('send', 'event', { eventCategory: 'FormSubmit', eventAction: 'FormSubmit', eventLabel: 'FormSubmit'});
        });
        
        $(".group3").colorbox({rel:'group3', transition:"fade", width:"80%", height:"80%"});

        $(window).resize(function(){

        });
      }
    },
    // Home page
    'home': {
        init: function() {
            // JavaScript to be fired on the home page
        },
        finalize: function() {
            var iframe = document.querySelector('iframe');
            var player = new Vimeo.Player(iframe);
            var browserH = $(window).height();

            $('.homevideo iframe').css({'height' : browserH});
            $('#fullpage').fullpage({
                //Navigation
                menu: '#menu',
                lockAnchors: false,
                anchors:['', ''],
                navigation: true,
                navigationPosition: 'right',
                navigationTooltips: ['intro', 'home'],
                showActiveTooltip: false,
                slidesNavigation: false,

                //Scrolling
                css3: true,
                scrollingSpeed: 800,
                autoScrolling: true,
                fitToSection: true,
                fitToSectionDelay: 1000,
                scrollBar: false,
                easing: 'easeInOutCubic',
                easingcss3: 'ease',
                loopBottom: false,
                loopTop: false,
                continuousVertical: false,
                scrollOverflow: true,
                scrollOverflowOptions: null,
                touchSensitivity: 15,
                normalScrollElementTouchThreshold: 5,

                //Accessibility
                keyboardScrolling: true,
                animateAnchor: true,
                recordHistory: true,

                //Design
                controlArrows: true,
                verticalCentered: true,
                sectionsColor : ['#000000', '#ffffff'],
                paddingTop: '40',
                paddingBottom: '40',
                fixedElements: '.content-info',
                responsiveWidth: 0,
                responsiveHeight: 0,
                onLeave: function(index, nextIndex, direction){},
                afterLoad: function(anchorLink, index){
                    if(index == 2){
                        $('header').fadeIn();
                        $('footer .blackoverlay').fadeOut();
                        player.pause();
                    }else{
                        $('footer .blackoverlay').fadeIn();
                        player.play();
                    }
                },
                afterRender: function(){
                    //$('video').get(0).play();
                },
                afterResize: function(){},
                afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){},
                onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){}
            });
            $('.btn_down').click(function(){
                $('#fp-nav ul li a span').eq(1).trigger('click');
            });

            /*document.getElementById('myVideo').addEventListener('ended',myHandler,false);
            function myHandler(e) {
                $('.home_btn_down').delay(3000).trigger('click');
            }*/

            player.on('ended', function(data){
                $('.home_btn_down').delay(2000).trigger('click');
            });
        }
    },
    'neighborhood': {
        init: function() {
            // JavaScript to be fired on the about us page
        },
        finalize: function() {
            maps();
        }
    },
    'gallery': {
        init: function() {
            // JavaScript to be fired on the about us page
        },
        finalize: function() {

        }
    }
  };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
          var fire;
          var namespace = Sage;
          funcname = (funcname === undefined) ? 'init' : funcname;
          fire = func !== '';
          fire = fire && namespace[func];
          fire = fire && typeof namespace[func][funcname] === 'function';

          if (fire) {
            namespace[func][funcname](args);
          }
        },
        loadEvents: function() {
          // Fire common init JS
          UTIL.fire('common');

          // Fire page-specific init JS, and then finalize JS
          $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm, 'finalize');
          });

          // Fire common finalize JS
          UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    var stylesArray = [
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 65
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 51
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#97a446"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#ab2d2d"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 30
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 40
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#636363"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#ffff00"
            },
            {
                "lightness": -25
            },
            {
                "saturation": -97
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": -25
            },
            {
                "saturation": -100
            }
        ]
    }
    ];
    var map;
    var mapDefaultStyle = false;
    var sitePath = "https://90weststreet.com/wp-content/themes/90west/assets/images";
    var allmarkers = [];
    var thisCat;
    var infoWindow = new google.maps.InfoWindow();

    function maps(){
        initialize();
        function initialize(){
            var browserW = $(window).width();
            var zoom;
            if(browserW > 1024){
                zoom = 15;
            }else{
                zoom = 14;
            }
            
            var minzoom;
            var latlng = new google.maps.LatLng(40.711977, -74.009337);
            var mapOptions = {
                center: latlng,
                zoom: zoom,
                maxZoom: 20,
                minZoom: 2,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                panControl: false,
                zoomControl: true,
                streetViewControl: false,
                scaleControl: false,
                overviewMapControl: false,
                mapTypeControl: false,
                scrollwheel: false
            };

            map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

            // Add Map 
            if(!mapDefaultStyle)map.setOptions({styles: stylesArray});

            //90 West icon
            var iconBase = {
                url: sitePath + '/logo_map.png',
                size: new google.maps.Size(120,108),
                scaledSize: new google.maps.Size(60,54),
                origin: new google.maps.Point(0,0),
                anchor: new google.maps.Point(0, 0)
            };
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(40.70993, -74.0144),
                map: map,
                icon: iconBase,
                zIndex: 99
            });

          google.maps.event.addDomListener(window, 'load', initialize);
        }
        $('ul.mapnav li span').click(function(){
            thisCat = $(this).attr('rel');
            $('ul.mapnav li').removeClass('active');
            $(this).parent('li').addClass('active');
            $('.markers:visible').slideUp();
            $(this).siblings('.markers').slideDown(800);
            clearMarkers();
            loadMarkers();
        });

        $('.markers li').click(function(){
            var thisIndex = $(this).index();
            google.maps.event.trigger(allmarkers[thisIndex], "click");
        });
    }
    function loadMarkers(){
        console.log('run loadMarks' + thisCat);
        switch(thisCat){
            case 'restaurants':
                var markers_cat = $('#restaurants li');
                break;
            case 'retail':
                var markers_cat = $('#retail li');
                break;
            case 'bars':
                var markers_cat = $('#bars li');
                break;
            case 'cafes':
                var markers_cat = $('#cafes li');
                break;
            case 'recreation':
                var markers_cat = $('#recreation li');
                break;
            case 'pier25':
                var markers_cat = $('#pier25 li');
                break;
            case 'landmarks':
                var markers_cat = $('#landmarks li');
                break;
            case 'parks':
                var markers_cat = $('#parks li');
                break;
            case 'grocery':
                var markers_cat = $('#grocery li');
                break;
            case 'pet':
                var markers_cat = $('#pet li');
                break;
            case 'universities':
                var markers_cat = $('#universities li');
                break;
            case 'museums':
                var markers_cat = $('#museums li');
                break;
        }
        allmarkers = allmarkers || [];
        for(var i = 0; i < markers_cat.length; i++){
            var name = markers_cat[i].getAttribute("data-name");
            var address = markers_cat[i].getAttribute("data-address");
            var latitude = markers_cat[i].getAttribute("data-latitude");
            var longitude = markers_cat[i].getAttribute("data-longitude");
            var website = markers_cat[i].getAttribute("data-website");
            var phone = markers_cat[i].getAttribute("data-phone");
            var markerImg = {
                url: sitePath + "/marker.png",
                size: new google.maps.Size(12, 12),
                scaledSize: new google.maps.Size(12,12),
                origin: new google.maps.Point(0,0),
                anchor: new google.maps.Point(6,6)
                };
            var point = new google.maps.LatLng(latitude,longitude);
            var html = "<div class='infow'><div class='title'>" + name + "</div>" + address + "<br>" + "<a target='_blank' href='http://" + website + "'>" + website + "</a>" + "<br>" + phone + "</div>";
            var marker = new google.maps.Marker({
                map: map,
                position: point,
                icon: markerImg,
                title: name,
                zIndex: 98
            });
            console.log(i, name, address, latitude, longitude, website, phone);
            allmarkers.push(marker);
            bindInfoWindow(marker, map, infoWindow, html);
        }
    }

    function bindInfoWindow(marker, map, infoWindow, html) {
        google.maps.event.addListener(marker, 'click', function() {
            var infowindow = new google.maps.InfoWindow({
                content: html
            });
            map.panTo(marker.getPosition());
            infoWindow.setContent(html);
            infoWindow.open(map, marker);
        });
    }

    function clearMarkers(){
        //console.log(markers.length);
        for (var i = 0; i < allmarkers.length; i++) {
            //map.markers.pop().setMap(null);
            allmarkers[i].setMap(null);
            //console.log(i, allmarkers[i]);
        }
        //allmarkers = [];
        allmarkers.length = 0;
        //console.log(l,'clear markers');
    }
})(jQuery); // Fully reference jQuery after this point.
